export default {
  flightBlocks: [],
  pagination: {},
  flightBlock: {}
}
